import _ from 'lodash';
import { useState } from 'react';
import { useEffectOnce, useMountedState, useTimeout } from 'react-use';
import { initializeIcons } from '@uifabric/icons';
import { Icon } from '@fluentui/react';
import iconNames from '@uifabric/icons/lib/data/AllIconNames.json';
import createContext from './context/createContext.js';
import AccessDenied from './AccessDenied.jsx';

global.SKYJS = { runtimeEnv: 'WEB' };

window._ = _;
window['__react-beautiful-dnd-disable-dev-warnings'] = true;

if (
  !navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
  !navigator.userAgent.toLowerCase().indexOf('msie') > -1
) {
  const oldInsertRule = CSSStyleSheet.prototype.insertRule;
  CSSStyleSheet.prototype.insertRule = function insertRuleNoException(rule, index) {
    if (
      rule?.indexOf('(-ms-high-contrast: active)') !== -1 ||
      rule?.indexOf('(forced-colors: active)') !== -1
    ) {
      return;
    }
    return oldInsertRule.apply(this, [
      rule
        ?.replace(/::-moz/g, '.moz-hack-')
        ?.replace(/::-ms-/g, '.ms-hack-')
        ?.replace(/:-ms-/g, '.ms-hack-')
        ?.replace(/\(-ms-/g, '.ms-hack-'),
      index
    ]);
  };
}

navigator.serviceWorker.register('/sw.js');

initializeIcons('https://skyjs-public.s3.ca-central-1.amazonaws.com/fabric-ui-11/assets/');
Icon.iconNames = _.compact(_.map(iconNames, 'name'));

const Loading = () => {
  const [ready] = useTimeout(1000);

  if (!ready()) {
    return null;
  }

  return <div className="loading-animation" />;
};

export default function Host() {
  const [context, setContext] = useState();
  const [forbidden, setForbidden] = useState(false);
  const isMounted = useMountedState();

  useEffectOnce(() => {
    const handleContextChange = c => {
      if (isMounted()) {
        setContext(c);
      }
      window.context = c;
    };

    createContext(handleContextChange).then(handleContextChange, reason => {
      const status = reason.response?.status;

      if (status === 403) {
        setForbidden(true);
      }
    });
  });

  if (forbidden) {
    return <AccessDenied />;
  }

  if (!context) {
    return <Loading />;
  }

  const appFile = _.find(context.app.files, { filename: 'web/App.js' });
  const App = context.app.importModule(appFile.moduleId);

  return <App context={context} {...context} />;
}
